(() => {
	angular.module('main').directive('addAutomationModal', addAutomationModal);

	addAutomationModal.$inject = [
		'$rootScope',
		'$q',
		'workflowService',
		'templateRequestsService',
		'messageService',
		'stringModifierService',
		'fileUploadService',
		'validationService',
		'utilsService',
		'$location',
		'workflowDataService',
		'newJobsDataService'
	];

	function addAutomationModal(
		$rootScope,
		$q,
		workflowService,
		templateRequestsService,
		messageService,
		stringModifierService,
		fileUploadService,
		validationService,
		utilsService,
		$location,
		workflowDataService,
		newJobsDataService
	) {
		return {
			restrict: 'E',
			scope: {
				jobId: '<',
				taskList: '=',
				templates: '<',
				fromSettings: '<',
				getJob: '&',
				renewWorkflow: '&',
				tickTask: '=',
				tickTaskType: '='
			},
			replace: true,
			template: `<div>
                    <div id="addAutomationModal" class="modal modal-center fade" data-backdrop="static" data-keyboard="false">
                        <div class="modal-dialog">
                    
                             <form role="form" name="addAutomation" ng-submit="fromSettings ? saveTaskFromSettings() : saveTask()">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <btn-close ng-click="close()"></btn-close>
                                        <h3 ng-if="!tickTask" class="modal-title">{{isForEdit ? 'Edit automation' : 'Add a new automation'}}</h3>
                                        <h3 ng-if="tickTask" class="modal-title">{{tickTaskType === 'CONTRACT' ? 'Send Contract' : 'Send Questionnaire' }}</h3>
                                    </div>
                                    <div class="modal-body f-s-14-i">
                                        <div class="form-group mb-8">
                                        
                                        <div class="field-info mb-25" ng-if="tickTask">
											<h4>To</h4>
											<div class="flex-row">
												<input type="text" autocomplete="off" class="form-control" ng-model="emailTo" disabled/>	
											</div>
										</div>
                                    
                                            <div class="row" ng-if="!tickTask">
                                                <h4 class="m-l-sm">Task name</h4>
                                                <div class="col-xs-12">
                                              
                                                    <input type="text" autocomplete="off" class="form-control" ng-model="newAutomation.name" required/>
                                                    
                                                </div>
                                            </div>
                    
                                            <div class="row mt-20" ng-if="!tickTask">
                                         
                                          
                                                <h4 class="m-l-sm">Action</h4>
                    
                                                <div class="col-xs-12">
                    
                                                    <div class="select-style">
                                                        <select ng-model="newAutomation.action"
                                                                ng-options="action.shortName as action.fullName for action in automatedActions | orderBy"
                                                                required>
                                                            <option value="" class="hide">Choose action</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                    
                                            <hr ng-if="!tickTask" class="mt-30 mb-30">
                                            
                                            <add-questionnaire  ng-if="newAutomation.action === 'SEND_QUESTIONNAIRE' && sources.questionnaireEmail.name || tickTaskType === 'QUESTIONNAIRE' && tickTask "
                                                                chosen-questionnaire = "sources.questionnaire"
                                                                email = "sources.questionnaireEmail"
                                                                email-templates = "questionnaireEmailTemplates" 
                                                                from-settings="fromSettings"
                                                                questionnaires = "questionnaires"
                                                                tick-task="tickTask"  
                                            ></add-questionnaire>
                                            
                                            <add-contract   ng-if="newAutomation.action === 'SEND_CONTRACT' && sources.contractEmail.name || tickTaskType === 'CONTRACT' && tickTask " 
                                                            chosen-contract="sources.contract"
                                                            contracts = "contracts"
                                                            edit-contract="editContract(contract)"
                                                            email = "sources.contractEmail"
                                                            email-templates = "contractEmailTemplates" 
                                                            from-settings="fromSettings"
                                                            on-change = "deleteUpdatedContract()"
                                                           	tick-task="tickTask"
                                            ></add-contract>
                                            
                                            <add-mail   ng-if="newAutomation.action === 'SEND_EMAIL' && sources.plainEmail && !fromSettings"
                                                        email-info="emailInfo"
                                                        email = "sources.plainEmail"
                                                        email-templates = "generalEmailTemplates"   
                                                        from-settings="fromSettings"
                                            ></add-mail>
                                            
                                            <add-mail-or-template  ng-if="newAutomation.action === 'SEND_EMAIL' && fromSettings"
                                                        email-info="emailInfo"
                                                        email-to-save = "sources.plainEmail"
                                                        email-templates = "generalEmailTemplates" 
                                            ></add-mail-or-template>
                    
                                            <div class="checkbox flex-row" ng-if="!tickTask">
                                                <div class="checkbox-squared wf-label">
                                                    <input id="checkbox-squared-has-due-date-auto" type="checkbox"
                                                           ng-model="newAutomation.hasDue">
                                                    <label for="checkbox-squared-has-due-date-auto"></label>
                                                </div>
                                                <label for="checkbox-squared-has-due-date-auto" class="checker f-s-14-i">
                                                    Send automatically on a due date
                                                </label>
                                            </div>
                    
                                            <div ng-if="!tickTask" class="row flex-row flex-align-center mt-20 flex-wrap-xs">
                                                <label class="col-xs-12 col-sm-1 control-label pull-left f-s-14-i mb-xs-10">Due</label>
                                                <div class="col-xs-12 col-sm-2 numb-style mb-xs-10 numb-no-fixed-width">
                                                    <input ng-disabled="!newAutomation.hasDue" data-number-input min="1"
                                                           class="form-control"
                                                           type="number" ng-model="newAutomation.due" autocomplete="off" required>
                                                </div>
                                                <div class="col-xs-12 col-sm-4 mb-xs-10">
                                                    <div class="select-style">
                                                        <select ng-disabled="!newAutomation.hasDue" ng-model="newAutomation.dateItem"
                                                                ng-options="item for item in dateItems | orderBy" required>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div class="col-xs-12 col-sm-5 mb-xs-10">
                                                    <div class="select-style">
                                                        <select ng-disabled="!newAutomation.hasDue" ng-model="newAutomation.dateSequence"
                                                                ng-options="item for item in taskDateSequence">
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="modal-footer modal-foot">
                                        <button type="submit" class="btn btn-lg btn-success" ng-disabled="button_disabled" 
                                        spinning-wheel is-spinning-wheel-active="button_disabled">
                                       		 <span ng-if="!tickTask">Save workflow task</span>
                                       		 <span ng-if="tickTask">{{tickTaskType === 'QUESTIONNAIRE' ? 'Send questionnaire': 'Send contract'}}</span>
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                        </div>
                      
                        <edit-contract-modal id="editContractFromWorkflowModal"
                                             close-edit-contract="closeEditContract()"
                                             editable-contract="editableContract"
                                             save-edited-contract="saveEditedContract()"
                        ></edit-contract-modal>
                        
                    </div>  

`,
			link(scope) {
				scope.emailInfo = {};

				let isFirstShow = true;
				scope.isLeadPage = $location.path().includes('/leads/');
				scope.isJobPage = $location.path().includes('/jobs/');
				const automationModal = '#addAutomationModal';
				const contractModal = '#editContractFromWorkflowModal';
				const emptyTextObj = {
					text: ''
				};

				const DEFAULT_EMAIL_NAME = 'Choose an existing email template';

				const emptyAttachmentsData = {
					attachments: [],
					filesSize: 0
				};

				const emptyEmail = {
					name: DEFAULT_EMAIL_NAME,
					text: '',
					attachmentsData: angular.copy(emptyAttachmentsData)
				};

				const prepareTemplates = () => {
					if (!scope.templates) {
						console.error('No templates loaded');
						return;
					}
					const templates = angular.copy(scope.templates);

					scope.contractEmailTemplates = templates.contractEmailTemplates;
					scope.contracts = templates.contracts;

					scope.questionnaireEmailTemplates =
						templates.questionnaireEmailTemplates;
					scope.questionnaires = templates.questionnaires;

					scope.generalEmailTemplates = templates.generalEmailTemplates;
				};

				const showErrorMessage = () => {
					messageService.showToaster('e_0', 'general');
				};

				const getDueOptions = () => {
					scope.taskDateSequence = workflowService.getTaskDateSequence();
					scope.dateItems = workflowService.getTaskDates();
				};

				const isItemSaved = item =>
					item.hasOwnProperty('id') && item.hasOwnProperty('templateId');

				const prepareQuestionnaire2Save = () => {
					const questionnaire2Save = scope.sources.questionnaire;
					const isUserQuestionnaire = isItemSaved(questionnaire2Save);

					const questionnaire = {
						id: isUserQuestionnaire ? scope.sources.questionnaire.id : null,
						templateId: isUserQuestionnaire
							? null
							: scope.sources.questionnaire.id
					};

					return questionnaire;
				};

				const prepareContract2Save = () => {
					const contract2Save = angular.copy(scope.sources.contract);

					let isUserContractNotEdited = true;

					if (scope.updatedContract) {
						isUserContractNotEdited = angular.equals(
							contract2Save,
							scope.updatedContract
						);
					}

					contract2Save.name =
						scope.updatedContract && !isUserContractNotEdited
							? scope.updatedContract.name
							: null;
					contract2Save.text =
						scope.updatedContract && !isUserContractNotEdited
							? scope.updatedContract.text
							: null;
					if (contract2Save.text) {
						contract2Save.text = $rootScope.addMaiStyling(contract2Save.text);
					}

					if (contract2Save.name) {
						contract2Save.name = stringModifierService.cutSelectedText(
							contract2Save.name
						);
					}

					return contract2Save;
				};

				const prepareEmailAttachments = taskEmail => {
					const deferred = $q.defer();

					const { attachmentsData } = taskEmail;

					const isAttachments =
						attachmentsData && attachmentsData.attachments.length;

					if (!isAttachments) {
						deferred.resolve(taskEmail);
						return deferred.promise;
					}

					const { attachments, filesSize } = attachmentsData;
					const maxSize = 10; // 10Mb

					if (filesSize > maxSize) {
						messageService.showToaster('w_0', 'attachments');
						deferred.reject('Attachments size exceeds the limit');
						return deferred.promise;
					}

					let uploadedAttachments, storedAttachments;

					if (attachments.length) {
						uploadedAttachments = attachments.filter(
							attachment => !attachment.id
						);
						storedAttachments = attachments.filter(attachment => attachment.id);
					}

					taskEmail.storedAttachments =
						storedAttachments && storedAttachments.length
							? storedAttachments
							: null;

					if (uploadedAttachments && uploadedAttachments.length) {
						fileUploadService
							.convertFileToSave(uploadedAttachments)
							.then(convertedFilesArr => {
								taskEmail.base64Attachments = convertedFilesArr;
								deferred.resolve(taskEmail);
							})
							.catch(error => console.log(error));
					} else {
						deferred.resolve(taskEmail);
					}

					delete taskEmail.attachmentsData;
					return deferred.promise;
				};

				const prepareEmail2save = taskEmail => {
					let {
						id,
						emailTemplateId,
						name,
						subject,
						text,
						storedAttachments,
						attachmentsData
					} = taskEmail;

					if (name === DEFAULT_EMAIL_NAME) {
						// name will be set on BackEnd
						name = null;
					}

					if (name) {
						name = stringModifierService.cutSelectedText(name);
					}

					return {
						emailTemplateId: emailTemplateId || id,
						name,
						subject,
						attachmentsData,
						storedAttachments,
						text
					};
				};

				const chooseObjectsToSave = task => {
					const task2Save = angular.copy(task);
					const action = task2Save.action;

					if (scope.fromSettings) {
						task2Save.contractId = null;
						task2Save.questionnaireId = null;
					}

					switch (action) {
						case 'SEND_EMAIL':
							task2Save.taskEmail = scope.sources.plainEmail;
							break;

						case 'SEND_QUESTIONNAIRE':
							task2Save.taskEmail = scope.sources.questionnaireEmail;
							if (scope.fromSettings) {
								task2Save.questionnaireId = scope.sources.questionnaire.id;
							} else {
								task2Save.questionnaire = prepareQuestionnaire2Save();
							}
							break;

						case 'SEND_CONTRACT':
							task2Save.taskEmail = scope.sources.contractEmail;

							if (scope.fromSettings) {
								task2Save.contractId = scope.sources.contract.templateId;
							} else {
								task2Save.contract = prepareContract2Save();
							}
							break;
						default:
							break;
					}

					if (!scope.fromSettings) {
						task2Save.taskEmail = prepareEmail2save(task2Save.taskEmail);
					}

					return task2Save;
				};

				scope.editContract = contract => {
					const isRealContract = contract.id;

					if (isRealContract && scope.updatedContract) {
						scope.editableContract = angular.copy(scope.updatedContract);
					} else if (isRealContract) {
						scope.editableContract = angular.copy(contract);
					} else if (scope.updatedContract && !isRealContract) {
						scope.editableContract = angular.copy(scope.updatedContract);
					} else if (!scope.updatedContract && !isRealContract) {
						const editContractTemplateCallback = data => {
							scope.editableContract = angular.copy(data);
						};
						templateRequestsService
							.getTemplates('contract_full', contract.templateId)
							.subscribe(
								data => editContractTemplateCallback(data),
								error => showErrorMessage()
							);
					} else {
						scope.editableContract = angular.copy(emptyTextObj);
						console.error('no selected contract');
					}

					utilsService.showNextModal(automationModal, contractModal);
				};

				scope.deleteUpdatedContract = () => {
					scope.updatedContract = null;
				};

				scope.closeEditContract = () => {
					$(contractModal)
						.modal('hide')
						.on('hidden.bs.modal', function() {
							isFirstShow = false;
							$(automationModal).modal('show');
							$(this).off('hidden.bs.modal');
						});
				};

				$(document).on('show.bs.modal', '#addAutomationModal', () => {
					scope.$broadcast('addedFileEvent');
				});

				scope.saveEditedContract = () => {
					const contractName = stringModifierService.cutSelectedText(
						scope.editableContract.name
					);
					messageService.showToaster('s_2', 'contractTemplates', contractName);
					$(contractModal)
						.modal('hide')
						.on('hidden.bs.modal', function() {
							scope.updatedContract = scope.editableContract;
							isFirstShow = false;
							$(automationModal).modal('show');
							$(this).off('hidden.bs.modal');
						});
				};

				const addDefaultEmails = () => {
					const sources = {};
					sources.contract = null;
					sources.contractEmail =
						scope.contractEmailTemplates.find(
							item => item.emailTemplateType === 'CONTRACT_EMAIL_TEMPLATE'
						) || {};
					sources.contractEmail.attachmentsData = angular.copy(
						emptyAttachmentsData
					);

					sources.questionnaire = null;
					sources.questionnaireEmail =
						scope.questionnaireEmailTemplates.find(
							item => item.emailTemplateType === 'QUESTIONNAIRE_EMAIL_TEMPLATE'
						) || {};
					sources.questionnaireEmail.attachmentsData = angular.copy(
						emptyAttachmentsData
					);

					sources.plainEmail = null;
					if (!scope.fromSettings) {
						sources.plainEmail = angular.copy(emptyEmail);
						scope.generalEmailTemplates.push(emptyEmail);
					}
					return sources;
				};

				const getContractById = id =>
					scope.contracts.find(contract => contract.templateId === id);

				const getQuestionnaireById = id =>
					scope.questionnaires.find(questionnaire => questionnaire.id === id);

				const addAttachments = email => {
					const emailCopy = angular.copy(email);

					if (
						emailCopy.storedAttachments &&
						emailCopy.storedAttachments.length
					) {
						emailCopy.attachmentsData = {
							attachments: fileUploadService.convertAttachmentsToShow(
								emailCopy.storedAttachments
							)
						};
					} else {
						emailCopy.attachmentsData = angular.copy(emptyAttachmentsData);
					}
					return emailCopy;
				};

				const setEmailTemplate = email => {
					scope.$broadcast('emailTemplateUpdated', email);
				};

				const prepareTaskToShow = task => {
					const sources = addDefaultEmails();
					const action = task.action;

					if (!scope.isForEdit) {
						return sources;
					}

					let email = angular.copy(task.taskEmail);
					if (email.name && !scope.fromSettings) {
						email.name = stringModifierService.addSelectedText(email.name);
					}

					email = addAttachments(email);

					switch (action) {
						case 'SEND_EMAIL':
							sources.plainEmail = email;
							if (scope.fromSettings) {
								setEmailTemplate(sources.plainEmail);
								scope.$evalAsync();
								scope.emailInfo.isEmailShown = !email.id;
							} else {
								scope.generalEmailTemplates.push(email);
							}
							break;

						case 'SEND_QUESTIONNAIRE':
							sources.questionnaireEmail = email;
							if (task.questionnaireId) {
								sources.questionnaire = getQuestionnaireById(
									task.questionnaireId
								);
							} else {
								const questionnaire = task.questionnaire;
								questionnaire.name = stringModifierService.addSelectedText(
									questionnaire.name
								);
								sources.questionnaire = questionnaire;
								scope.questionnaires.push(questionnaire);
								scope.questionnaireEmailTemplates.push(email);
							}

							break;

						case 'SEND_CONTRACT':
							sources.contractEmail = email;
							if (task.contractId) {
								sources.contract = getContractById(task.contractId);
							} else {
								const contract = angular.copy(task.contract);
								contract.name = stringModifierService.addSelectedText(
									contract.name
								);
								sources.contract = contract;
								scope.updatedContract = angular.copy(contract);
								scope.contracts.push(contract);
								scope.contractEmailTemplates.push(email);
							}

							break;
						default:
							break;
					}

					return sources;
				};

				const successTaskSave = (task, taskTypes, id) => {
					const isEdited = id !== null && id !== undefined;

					prepareEmailAttachments(task.taskEmail).then(
						result => {
							task.taskEmail = result;
							scope.taskList = workflowService.pasteNewTaskInList(
								taskTypes,
								task
							); // modifies workflow list
							scope.taskList = workflowService.renewTaskViewDue(scope.taskList);
							isFirstShow = true;
							isEdited
								? messageService.showToaster('s_4', 'workflow')
								: messageService.showToaster('s_3', 'workflow');
							$(automationModal).modal('hide');
						},
						error => {
							scope.button_disabled = false;
							console.error(error);
						}
					);
				};

				const errorValidateEmailName = data => {
					const error = data.errorMessage;
					if (
						error &&
						error === 'Email template with same name is already exist'
					) {
						messageService.showToaster('e_8', 'emailTemplate');
					} else {
						showErrorMessage();
					}
				};

				scope.saveTaskFromSettings = () => {
					const wasEmailFieldShown = scope.emailInfo.isEmailShown;
					scope.button_disabled = true;
					scope.emailInfo.isEmailShown = false;
					const task2Save = chooseObjectsToSave(scope.newAutomation);

					if (!workflowService.isTaskValid(task2Save, 'fromSettings')) {
						scope.emailInfo.isEmailShown = wasEmailFieldShown;
						scope.button_disabled = false;
						return;
					}

					if (task2Save.action === 'SEND_EMAIL') {
						workflowService
							.validateEmailName(task2Save.taskEmail)
							.finally(() => (scope.button_disabled = false))
							.subscribe(
								() => successTaskSave(task2Save, scope.taskList),
								result => errorValidateEmailName(result.data)
							);
						return;
					}

					const { id: emailTemplateId } = task2Save.taskEmail;

					workflowService
						.validateEmailLinks(task2Save.action, emailTemplateId)
						.finally(() => (scope.button_disabled = false))
						.subscribe(
							() => successTaskSave(task2Save, scope.taskList, task2Save.id),
							result => workflowService.errorSaveTask(result.data)
						);
				};

				const renewWorkflow = (data, id) => {
					scope.tickTask = false;
					scope.tickTaskType = '';
					if (!data || !data.tasks) {
						return;
					}

					scope.renewWorkflow({ tasks: data.tasks });

					const isEdited = id !== null && id !== undefined;

					messageService.showToaster('i_0', 'jobView');

					isFirstShow = true;
					if (!scope.tickTask) {
						isEdited
							? messageService.showToaster('s_4', 'workflow')
							: messageService.showToaster('s_3', 'workflow');
					} else {
						scope.tickTaskType === 'QUESTIONNAIRE'
							? messageService.showToaster('s_9', 'jobView')
							: messageService.showToaster('s_4', 'jobView');
					}

					scope.getJob();
					delete scope.sources;
					$(automationModal).modal('hide');
				};

				const doSaveTaskRequest = task => {
					if (scope.tickTask) {
						saveCompletedTask(task);
					} else {
						saveTaskRequest(task);
					}
				};

				function saveTaskRequest(task) {
					workflowService
						.saveTask(task, scope.jobId, scope.taskList)
						.finally(() => (scope.button_disabled = false))
						.subscribe(
							data => renewWorkflow(data, task.id),
							result => workflowService.errorSaveTask(result.data),
							() => (scope.button_disabled = false)
						);
				}

				function saveCompletedTask(task) {
					scope.taskId = task.id;
					workflowService.saveTask(task, scope.jobId, scope.taskList).subscribe(
						data => {
							const tasks = data;
							const taskToComplete = angular.copy(
								data.tasks.find(task => task.id === scope.taskId)
							);
							taskToComplete.jobId = scope.jobId;
							saveEditTask(taskToComplete).subscribe(
								dataTask => {
									renewWorkflow(tasks, dataTask.id);
								},
								result => {
									scope.button_disabled = false;
									workflowService.errorSaveTask(result.data);
								},
								() => (scope.button_disabled = false)
							);
						},
						error => {
							scope.button_disabled = false;
							const { errorMessage } = error.error;
							switch (errorMessage) {
								case 'Email text should contain a questionnaire link':
									messageService.showToaster('e_0', 'questionnaires');
									break;
								case 'Email text should contain a contract link':
									messageService.showToaster('e_0', 'contract');
									break;
								default:
									messageService.showErrorFromBackend(
										'Whoops, something has gone wrong!',
										errorMessage
									);
									break;
							}
						}
					);
				}

				function saveEditTask(task) {
					return workflowDataService.saveTask(task).switchMap(data => {
						const taskToComplete = angular.copy(
							data.tasks.find(task => task.id === scope.taskId)
						);
						taskToComplete.completed = true;
						taskToComplete.jobId = scope.jobId;
						return changeState(taskToComplete);
					});
				}

				function changeState(taskToComplete) {
					return newJobsDataService.changeTaskState(
						scope.jobId,
						taskToComplete
					);
				}

				const saveTaskWithAttachments = task => {
					prepareEmailAttachments(task.taskEmail).then(
						result => {
							task.taskEmail = result;
							doSaveTaskRequest(task);
						},
						error => {
							scope.button_disabled = false;
						}
					);
				};

				scope.saveTask = () => {
					const task2Save = chooseObjectsToSave(scope.newAutomation);

					if (task2Save.action === undefined) {
						scope.button_disabled = false;
					} else {
						scope.button_disabled = true;
					}
					const { attachmentsData } = task2Save.taskEmail;

					const isAttachments =
						attachmentsData && attachmentsData.attachments.length;

					if (isAttachments) {
						saveTaskWithAttachments(task2Save);
					} else {
						delete task2Save.taskEmail.attachmentsData;
						delete task2Save.taskEmail.storedAttachments;
						doSaveTaskRequest(task2Save);
					}
				};

				scope.close = () => {
					scope.tickTask = false;
					scope.tickTaskType = '';
					isFirstShow = true;
					scope.emailInfo.isEmailShown = false;
					delete scope.sources;
					if (scope.isLeadPage) {
						$rootScope.updateLeadView();
					} else if (scope.isJobPage) {
						$rootScope.updateJobView();
					}
				};

				$(document)
					.on('show.bs.modal', automationModal, () => {
						if (isFirstShow) {
							isFirstShow = false;
							scope.taskInfo = workflowService.getTaskInfo();
							scope.isForEdit = scope.taskInfo.isForEdit;
							scope.newAutomation = angular.copy(scope.taskInfo.task);
							scope.automatedActions = workflowService.getAutomatedActions();
							if (scope.isLeadPage || scope.isJobPage) {
								scope.emailTo = $rootScope.primaryContact.email;
							}
							getDueOptions();
							prepareTemplates();

							const {
								questionnaireEmail = {},
								contractEmail = {},
								plainEmail = {},
								questionnaire = {},
								contract = {}
							} = prepareTaskToShow(scope.newAutomation);

							scope.sources = {
								questionnaireEmail,
								contractEmail,
								plainEmail,
								questionnaire,
								contract
							};
							scope.$evalAsync();
						}
					})
					.on('shown.bs.modal', automationModal, () => {
						$(this)
							.find('input')
							.first()
							.focus();
						const input = $(this).find('input');
						const select = $(this).find('select');

						validationService.isModalClosePrevented(input);
						validationService.isModalClosePrevented(select);
					});
			}
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/Workflow/Modals/addAutomationModal.js